import { Outlet, useLocation } from "react-router-dom";
import { Player } from "./Player";
import { PlaylistModal } from "./PlaylistModal";
import styles from "./styles/Layout.module.css";

export const Layout = () => {
    const { pathname } = useLocation();
    return (
        <div className={"main " + styles.main}>
            <div className="container">
                <div
                    className={styles.adsense}
                    key={`adsense-${pathname}`}
                    style={{
                        position: "sticky",
                        top: 80,
                        zIndex: 10000,
                        backgroundColor: "#e6f0ff",
                        padding: "12px 16px",
                        border: "1px solid #0077cc",
                        textAlign: "center",
                        marginBottom: "16px",
                        maxWidth: "100%",
                        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                    }}>
                    <a
                        href="https://to.tv4play.se/t/t?a=1948999804&as=1628518118&t=2&tk=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            color: "#004a99",
                            fontWeight: 400,
                            textDecoration: "none",
                            display: "inline-block",
                        }}>
                        ⚽ Se Allsvenskan, Superettan, Serie A & LaLiga – 249 kr/mån{" "}
                        <small>
                            (<s>349 kr/mån</s>)
                        </small>{" "}
                        i 6 månader.
                        <br />
                        <strong>Ta del av erbjudandet (spara 600 kr)</strong>
                    </a>
                    <img
                        src="https://track.adtraction.com/t/t?a=1948999804&as=1628518118&t=1&tk=1&i=1"
                        width="1"
                        height="1"
                        alt="TV4Play"
                    />
                </div>

                <Outlet />
            </div>
            <Player key="7" />
            <PlaylistModal />
        </div>
    );
};
